"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { Phone, Scale, DollarSign } from "lucide-react"

export default function RoughEmeraldCard({ emerald }) {
  const [isHovered, setIsHovered] = useState(false)

  const whatsappLink = `https://wa.me/+93729599599?text=I'm interested in the ${emerald.weight}g rough Panjshir emerald from Dubai Panjshir EmeraldVault`

  return (
    <motion.div
      className="relative overflow-hidden rounded-xl bg-neutral-100 shadow-xl h-full"
      style={{ minHeight: "500px" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{
        y: -8,
        boxShadow: "0 30px 60px -15px rgba(0, 0, 0, 0.3)",
        transition: { duration: 0.3 },
      }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={emerald.image || "/placeholder.svg"}
          alt={`${emerald.weight}g rough Panjshir emerald`}
          className="w-full h-full object-cover"
        />

        <motion.div
          className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="p-6 w-full">
            <motion.div
              className="flex items-center gap-2 text-white"
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: isHovered ? 0 : 10, opacity: isHovered ? 1 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <h3 className="text-2xl font-serif tracking-wide drop-shadow-md">Panjshir Valley</h3>
            </motion.div>
          </div>
        </motion.div>
      </div>

      <div className="p-6 bg-gradient-to-b from-neutral-100 to-neutral-200">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            {/* <Scale className="w-5 h-5 text-emerald-700" /> */}
            {/* <h3 className="text-2xl font-serif tracking-wide text-emerald-900">{emerald.weight}g</h3> */}
          </div>

          <div className="flex items-center gap-1 text-emerald-700">
            {/* <DollarSign className="w-5 h-5" /> */}
            {/* <span className="text-xl font-serif">{emerald.price}</span> */}
          </div>
        </div>

      
        <div className="mt-4 mb-3">
          <p className="text-base text-neutral-700">
            Exquisite rough Panjshir emerald from Dubai Panjshir EmeraldVault, sourced from Afghanistan’s Panjshir Valley.
          </p>
        </div>

        <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="block mt-4">
          <motion.button
            className="w-full py-3 bg-emerald-700 text-white rounded-lg flex items-center justify-center gap-2 hover:bg-emerald-800 transition-colors text-base"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <Phone className="w-5 h-5" /> Contact via WhatsApp
          </motion.button>
        </a>
      </div>
    </motion.div>
  )
}